module.exports = __webpack_public_path__ + "img/download.432ca7cb.png";